/* Cart presentation only. The existing app owns membership, plans and signup. */
(() => {
  function init(root) {
    const panel = root.querySelector('[data-cart-prime]');
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const toggle = panel.querySelector('summary');
    const member = panel.querySelector('[data-prime-member]');
    const join = panel.querySelector('[data-prime-join]');
    const comparison = panel.querySelector('[data-cart-prime-comparison]');
    const body = panel.querySelector('.park-cart-prime__body');
    const isMember = () => panel.dataset.member === 'true' || !!(member && !member.hidden);
    toggle.addEventListener('click', event => { if (isMember()) event.preventDefault(); });
    const sync = () => {
      const totals = root.querySelector('[data-cart-total]');
      const activeMember = isMember();
      const count = Number(totals?.dataset.cartCount || 0);
      panel.parentElement.hidden = count === 0;
      if (activeMember && !panel.open) panel.open = true;
      body.hidden = activeMember;
      toggle.setAttribute('aria-checked', String(activeMember || panel.open));
      if (activeMember) {
        toggle.setAttribute('aria-disabled', 'true');
        toggle.removeAttribute('aria-controls');
      } else {
        toggle.removeAttribute('aria-disabled');
        toggle.setAttribute('aria-controls', body.id);
      }
      // Avoid suggesting that already-discounted orders get another 20% off.
      const showComparison = count > 0 && !activeMember && Number(totals?.dataset.cartDiscount) === 0;
      comparison.hidden = !showComparison;
      if (showComparison) {
        const amount = Number(totals.dataset.cartTotal);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {style:'currency',currency:totals.dataset.cartCurrency || 'DKK'});
        const normal = panel.querySelector('[data-cart-prime-normal]');
        const price = panel.querySelector('[data-cart-prime-price]');
        const normalText = money.format(amount / 100);
        const primeText = money.format(Math.round(amount * .8) / 100);
        if (normal.textContent !== normalText) normal.textContent = normalText;
        if (price.textContent !== primeText) price.textContent = primeText;
      }
      if (panel.open && join && !join.hidden && !activeMember) {
        // Use the app's own opener, including async plans/terms and error handling.
        join.querySelector('[data-prime-open]')?.click();
      }
    };
    panel.addEventListener('toggle', sync);
    const observer = new MutationObserver(sync);
    observer.observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['data-cart-total','data-cart-count','data-cart-discount']});
    // Membership arrives asynchronously. A switch opened early still opens the form.
    const stateObserver = new MutationObserver(sync);
    if (join) stateObserver.observe(join, {attributes:true,attributeFilter:['hidden']});
    if (member) stateObserver.observe(member, {attributes:true,attributeFilter:['hidden']});
    const unload = e => {
      if (!e.target.contains(root)) return;
      observer.disconnect(); stateObserver.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }
  document.querySelectorAll('.park-main-cart').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.park-main-cart').forEach(init));
})();
